import { render } from "./OfficeTasksCard.vue?vue&type=template&id=3625252d&scoped=true&bindings={}"
import script from "./OfficeTasksCard.vue?vue&type=script&lang=ts"
export * from "./OfficeTasksCard.vue?vue&type=script&lang=ts"

import "./OfficeTasksCard.vue?vue&type=style&index=0&id=3625252d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3625252d"

export default script